import { api } from "./client";

export type IntegrationStatus = "configured" | "not_configured" | "coming_soon";

export type IntegrationState = {
  enabled: boolean;
  status: IntegrationStatus;
  config?: Record<string, string>;
  updatedAt?: string;
};

export type IntegrationProvider = {
  id: string;
  name: string;
  description: string;
  category: "clearinghouse" | "ehr" | "other";
  defaultStatus: IntegrationStatus;
  fields?: Array<{ key: string; label: string }>;
  state: IntegrationState;
};

export type IntegrationsResponse = {
  providers: IntegrationProvider[];
  /** Enabled AI adapter ids (BAA gating). null = not yet configured (use UI default). */
  adapters: { enabled: string[] | null };
};

export const integrationsApi = {
  get: (companyId: string) =>
    api.get<IntegrationsResponse>(`/companies/${companyId}/integrations`),
  updateProvider: (
    companyId: string,
    providerId: string,
    body: { enabled?: boolean; config?: Record<string, string> },
  ) =>
    api.put<IntegrationsResponse>(
      `/companies/${companyId}/integrations/${providerId}`,
      body,
    ),
  updateAdapters: (companyId: string, enabled: string[]) =>
    api.put<IntegrationsResponse>(
      `/companies/${companyId}/integrations/adapters`,
      { enabled },
    ),
};
